import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const createPOSOpeningEntry = (branchName, formData) => {
    const params = {
        doc: JSON.stringify(formData),
        action: `Submit`,
    };
    try {
        return axios.post(`method/frappe.desk.form.save.savedocs`, params);
    } catch (err) {
        throw new err();
    }
};

export const usePOSEntryCreateData = () => {
    return useMutation(async ({ branchId, formData }) => {
        const data = await createPOSOpeningEntry(branchId, formData);
        return data;
    });
};

export const useGetParyDetails = () => {
    return useMutation(async ({ company, party_type, party, date }) => {
        const payload = {
            company,
            party_type,
            party,
            date,
        };
        const data = await axios.post(
            "method/erpnext.accounts.doctype.payment_entry.payment_entry.get_party_details",
            payload
        );
        return data;
    });
};

export const useGetIncomingRate = () => {
    return useMutation(async ({ args }) => {
        const payload = {
            args,
        };
        const data = await axios.post(
            "method/erpnext.stock.utils.get_incoming_rate",
            payload
        );
        return data;
    });
};

const createPOSClosingEntry = (formData) => {
    const params = {
        // doctype:`POS Closing Entry`,
        doc: JSON.stringify(formData),
        action: `Submit`,
    };
    try {
        return axios.post(`method/frappe.desk.form.save.savedocs`, params);
    } catch (err) {
        throw new err();
    }
};

export const usePOSEntryCloseCreateData = () => {
    return useMutation(async ({ formData }) => {
        const data = await createPOSClosingEntry(formData);
        return data;
    });
};

export const useFetchPosLinkedInvoices = () => {
    return useMutation(async ({ startDate, endDate, posProfile, user }) => {
        const { data } = await getClosingEntryInvoices(
            startDate,
            endDate,
            posProfile,
            user
        );
        return data;
    });
};

export const useGetSalesData = ({
    company,
    pos_profile,
    // start,
    // end,
    opening_amount,
}) => {
    const data = useQuery(
        ["useGetSalesData", pos_profile],
        async () => {
            const params = {
                company,
                pos_profile,
                // start,
                // end,
                opening_amount,
            };
            const response = await axios.get(
                `method/restaurant_management.api.get_sales`,
                { params }
            );

            const _meta = response.data.message;
            _meta.data = _meta.fields;
            return _meta;
        },
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            enabled: !!pos_profile,
            cacheTime: Infinity,
        }
    );

    return data;
};

//TODO WAS HERE .. CREATE MUTATION INSTEAD OF useQuery for getClosingEntryInvoices and implement in OpeningEntries

const getClosingEntryInvoices = (startDate, endDate, posProfile, user) => {
    const params = {
        start: startDate,
        end: endDate,
        pos_profile: posProfile,
        user: user,
    };
    try {
        return axios.post(
            `method/erpnext.accounts.doctype.pos_closing_entry.pos_closing_entry.get_pos_invoices`,
            params
        );
    } catch (err) {
        throw new err();
    }
};

export const useGetClosingInvoicesData = (
    startDate,
    endDate,
    posProfile,
    user,
    onSuccess,
    onError
) => {
    return useQuery(
        ["GetClosingInvoices", startDate, endDate],
        async () => {
            const { data } = await getClosingEntryInvoices(
                startDate,
                endDate,
                posProfile,
                user
            );
            return data.message;
        },
        {
            onSuccess,
            onError,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            enabled: !!startDate && !!endDate && !!posProfile && !!user,
        }
    );
};

const closeCash = ({
    company,
    pos_profile,
    expected_amount,
    amount_in_register,
    opening_amount,
    credit_card_amount,
}) => {
    const params = {
        company,
        pos_profile,
        opening_amount,
        expected_amount,
        amount_in_register,
        credit_card_amount,
    };
    try {
        return axios.post(
            `method/restaurant_management.api.close_cash`,
            params
        );
    } catch (err) {
        throw new err();
    }
};

export const useCloseCash = () => {
    return useMutation(
        async ({
            company,
            pos_profile,
            opening_amount,
            expected_amount,
            amount_in_register,
            credit_card_amount,
        }) => {
            const data = await closeCash({
                company,
                pos_profile,
                expected_amount,
                amount_in_register,
                opening_amount,
                credit_card_amount,
            });
            return data;
        }
    );
};

// Fetch cash-out transactions for POS closing
const getCashOutTransactions = (startDate, endDate, company, user) => {
    const params = {
        start_date: startDate,
        end_date: endDate,
        company: company,
        user: user,
    };
    try {
        return axios.post(
            `method/restaurant_management.api.get_cashout_transactions`,
            params
        );
    } catch (err) {
        throw new err();
    }
};

export const useGetCashOutTransactions = (
    startDate,
    endDate,
    company,
    user,
    onSuccess,
    onError
) => {
    return useQuery(
        ["GetCashOutTransactions", startDate, endDate, company, user],
        async () => {
            const { data } = await getCashOutTransactions(
                startDate,
                endDate,
                company,
                user
            );
            return data.message;
        },
        {
            onSuccess,
            onError,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            enabled: !!startDate && !!endDate && !!company && !!user,
        }
    );
};

const searchPOSOpenining = () => {
    const params = {
        fields: JSON.stringify(["*"]),
        expand: JSON.stringify(["balance_details"]),
        filters: JSON.stringify([
            ["status", "=", "open"],
            ["docstatus", "=", "1"],
        ]),
        limit: 0,
    };
    try {
        return axios.get(`resource/POS Opening Entry`, { params });
    } catch (err) {
        throw new err();
    }
};

export const useSearchPOSOpening = (onSuccess, onError) => {
    return useQuery(
        ["searchPOSOpenining"],
        async () => {
            const { data } = await searchPOSOpenining();
            return data.data;
        },
        {
            onSuccess,
            onError,
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            cacheTime: 30 * 1000 * 60 * 60 * 24,
        }
    );
};

export const useGetPosEntryDetails = (name) => {
    return useQuery(
        ["getPosEntryDetails"],
        async () => {
            const { data } = await fetchDocType("POS Opening Entry", name);
            return data.message;
        },
        {
            enabled: !!name,
            cacheTime: 0,
            refetchOnMount: true,
            refetchOnReconnect: true,
        }
    );
};

const fetchDocType = (doctype, name) => {
    const params = {
        doctype,
        name,
    };

    return axios.get(`method/frappe.client.get`, { params });
};
